import styled from 'styled-components';

export const FallbackContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.s4};
  text-align: center;
  border: 1px solid '#ddd';
  border-radius: ${({ theme }) => theme.spacing.s2};
  background-color: '#f9f9f9';
  color: '#1a1a1a';
`;
export const ErrorDetails = styled.details`
  margin-top: ${({ theme }) => theme.spacing.s2};
  text-align: left;
`;

export const ErrorPre = styled.pre`
  font-size: ${({ theme }) => theme.fontSize.small};
  overflow: auto;
`;
